// Section 16: Harsh justice norm. Established by flogging, exile and execution (4 uses in a row;
// reset by a pardon or restitution; imprisonment is neutral); lost after 8 seasons without
// reinforcement. Effect once established: deterrence baseline 1.3x; Gentle and Devout people lose
// 1 trust per season (society phase, cause `norm-harsh-justice`).
// Constants: config.normRules, config.norms['harsh-justice'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { targetPerson } from '../../core/content-helpers';
import { defineNorm } from '../../core/registry';

const HARSH: readonly string[] = ['flogging', 'exile', 'execution'];
const LENIENT: readonly string[] = ['pardon', 'restitution'];

export function harshJustice(config: Config) {
  const c = config.norms['harsh-justice'];

  return defineNorm({
    id: 'harsh-justice',
    label: 'Harsh justice',
    section: 'S16',
    establishAfter: config.normRules.establishAfter,
    decayAfter: config.normRules.decayAfter,
    reinforcedBy: (_ctx, entry) => entry.kind === 'justice' && HARSH.includes(entry.response),
    contradictedBy: (_ctx, entry) => entry.kind === 'justice' && LENIENT.includes(entry.response),
    modifierTargets: ['deterrence', 'trustChange'],
    modifierKeys: { trustChange: ['norm-harsh-justice'] },
    modifiers(ctx, target) {
      if (!ctx.state.norms['harsh-justice'].established) return [];
      if (target.kind === 'deterrence')
        return [mod.mul('norm:harsh-justice', c.deterrence, 'harsh justice')];
      if (target.kind !== 'trustChange' || target.cause !== 'norm-harsh-justice') return [];
      const p = targetPerson(ctx, target);
      return p !== null && (p.traits.includes('gentle') || p.traits.includes('devout'))
        ? [mod.add('norm:harsh-justice', c.gentleDevoutTrustPerSeason, 'troubled by harsh justice')]
        : [];
    },
  });
}
